import { MoneyValue } from '@shared/design-system/ui'
import type { LedgerItem, SaleItem } from '../api/admin.api'
import { providerChargeResult } from '../lib/provider-charge-result'
import {
  muted,
  saleLine,
  saleLineHint,
  saleLineLabel,
  saleLineValue,
  saleSection,
  saleSectionTitle,
  saleSoftNote,
} from './admin.css'

export function AdminProviderChargeResult({
  sale,
  entries,
  loading,
  error,
}: {
  sale: SaleItem
  entries: LedgerItem[]
  loading: boolean
  error: boolean
}) {
  const result = !loading && !error ? providerChargeResult(sale, entries) : null
  const provider = sale.gateway === 'STRIPE' ? 'Stripe' : 'provedor'
  const rows = [
    {
      label: `Bruto recebido ${provider === 'Stripe' ? 'da Stripe' : 'do provedor'}`,
      amount: sale.providerSettlementAmount,
    },
    { label: 'Destinado aos participantes', amount: result?.participants },
    { label: 'VendePay antes dos custos', amount: result?.platformGross },
    {
      label: `Custos da ${provider === 'Stripe' ? 'Stripe' : 'operação no provedor'}`,
      amount: sale.providerFeeAmount,
    },
    { label: 'Resultado VendePay após custos do provedor', amount: result?.platformNet },
  ]
  return (
    <section className={saleSection} aria-label="Conferência com o provedor">
      <span className={saleSectionTitle}>Conferência com o provedor</span>
      <span className={saleLineHint}>
        Cobrança original, antes de reembolsos, contestações e outros custos. Não representa saldo
        disponível ou pagamento bancário.
      </span>
      {rows.map((row) => (
        <div className={saleLine} key={row.label}>
          <span className={saleLineLabel}>{row.label}</span>
          <span className={saleLineValue}>
            {row.amount ? (
              <MoneyValue amount={row.amount.amount} currency={row.amount.currency} size="sm" />
            ) : (
              <span className={muted}>{loading ? 'Conferindo...' : 'Não disponível'}</span>
            )}
          </span>
        </div>
      ))}
      <div className={saleSoftNote}>
        <span>
          VendePay antes dos custos inclui serviço, conversão e outros lançamentos da cobrança. Os
          custos do provedor não são uma nova dedução dos participantes.
        </span>
        {!result ? (
          <span>
            Resultado indisponível até os valores do provedor e a distribuição da cobrança estarem
            completos e na mesma moeda.
          </span>
        ) : null}
      </div>
    </section>
  )
}
